import { SHOW, HIDE } from "./constants";
import React from "react";
import { StyledMessage } from "ui-kit/Snackbar";

export function showSnackbar(payload) {
  return {
    type: SHOW,
    payload: {
      ...payload,
      key: Math.random()
    }
  };
}

export function showStyledSnackbar(payload, style) {
  const styledMessage = (
    <StyledMessage style={style}>{payload.message}</StyledMessage>
  );

  return {
    type: SHOW,
    payload: {
      ...payload,
      message: styledMessage,
      key: Math.random()
    }
  };
}

export function hideSnackbar() {
  return {
    type: HIDE
  };
}
